"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable camelcase */
var userDeletionApi_1 = require("../mock/userDeletionApi");
var fetchApi_1 = __importDefault(require("../../rest/fetchApi"));
var combinePlatformUrl_1 = __importDefault(require("./combinePlatformUrl"));
var UserDeletionAPIs = {
    deleteUsers: function (body) {
        return fetchApi_1.default.delete({ mockFunc: userDeletionApi_1.deleteUsers, url: (0, combinePlatformUrl_1.default)('/api/v2/user_deletion/delete_users'), body: body });
    },
    asyncJobProgress: function (job_id) {
        return fetchApi_1.default.get({ mockFunc: userDeletionApi_1.asyncJobProgress, url: (0, combinePlatformUrl_1.default)("/api/v2/async_job_progress/".concat(job_id)) });
    },
    fetchUserDeletionData: function () {
        return fetchApi_1.default.get({
            mockFunc: userDeletionApi_1.fetchUserDeletionData,
            url: (0, combinePlatformUrl_1.default)('/api/v2/user_deletion/get_user_deletion_data'),
        });
    },
};
exports.default = UserDeletionAPIs;
